import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import MDEditor from "@uiw/react-md-editor";

import { useStore } from "../../utils/store";

import { publishDraft } from "../../utils/apis";

import { showToast } from "../../utils/hot-toast";
import HoverList from "../UI/HoverList";
import LoadingBar from "../UI/LoadingBar";

import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import ProfileBadge from "../UI/ProfileBadge";
import HoverGiphy from "../UI/HoverGiphy";

import { BsFacebook, BsTwitter } from "react-icons/bs";
import { FiShare2 } from "react-icons/fi";
import { IoIosCopy } from "react-icons/io";
import { MdPublish } from "react-icons/md";
import { AiOutlineGif } from "react-icons/ai";
import LinkWithSearchParams from "../UI/LinkWithSearchParams";
import { RiDeleteBin2Line } from "react-icons/ri";

const PostComposer = () => {
    const { library } = useWeb3React();
    const navigate = useNavigate();

    // const [drawerVisible, setDrawerVisible] = useState(true);
    // const [isPreviewing, setIsPreviewing] = useState(false);

    const profile = useStore((state) => state.profile);
    const draft = useStore((state) => state.draft);
    const resetDraft = useStore((state) => state.resetDraft);
    const fetchDraft = useStore((state) => state.fetchDraft);
    const updateDraft = useStore((state) => state.updateDraft);
    const setSubject = useStore((state) => state.setSubject);
    const setMarkdown = useStore((state) => state.setMarkdown);
    const setTags = useStore((state) => state.setTags);
    const setGiphyLink = useStore((state) => state.setGiphyLink);

    const [notice, setNotice] = useState("");

    const onBlurMarkdown = async () => {
        setTimeout(() => updateDraft(), 1000);
    };

    const onGifClick = (gif, e) => {
        e.preventDefault();
        if (gif?.images?.original?.webp) {
            setGiphyLink(gif?.images?.original?.webp);
            onBlurMarkdown();
        }
    };

    const onChangeEditor = (markdown) => {
        setMarkdown(markdown);
    };

    useEffect(() => {
        if (profile?.wallet) fetchDraft(profile.wallet);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    const onPublishDraft = async () => {
        if (!profile) {
            showToast("Info", "Connect wallet first to write a article!");
            return;
        }
        window.web3 = new Web3(library?.provider);
        const web3 = window.web3;
        if (!web3) return;

        setNotice("Verifying you are correct owner of this wallet...");
        try {
            const signatureHash = await web3.eth.personal.sign(
                draft.link,
                profile.wallet
            );
            const result = await publishDraft(draft._id, signatureHash);

            console.log(result, signatureHash);
            if (result.link) {
                setNotice("");
                showToast("SUCCESS", "Successfully posted!");
                resetDraft();
                navigate(`/feeds/${result.link}`);
            } else {
                showToast("ERROR", "Something went wrong!");
                setNotice("");
                return;
            }
        } catch (error) {
            console.log(error);
            showToast("ERROR", "Something went wrong!");
            setNotice("");
        }
        setNotice("");
    };

    const shareOptions = {
        icon: <FiShare2 className="" />,
        options: [
            {
                icon: <IoIosCopy className="size-1" />,
                text: "Copy Draft Link",
                handler: () => {
                    navigator.clipboard.writeText(
                        `${window.location.origin}/posts/${draft?.link}`
                    );
                    showToast(
                        "SUCCESS",
                        "Draft link was copied to clipboard!",
                        "📋"
                    );
                },
            },
            {
                icon: <BsFacebook className="size-1" />,
                text: "Share on Facebook",
                handler: () => {
                    const shareLink = `https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}/posts/${draft?.link}`;
                    window.open(shareLink, "_blank").focus();
                },
            },
            {
                icon: <BsTwitter className="size-1" />,
                text: "Share on Twitter",
                handler: () => {
                    const shareLink = `https://twitter.com/intent/tweet?text=Read this article on Kadido&url=${window.location.origin}/posts/${draft?.link}&via=kadido`;
                    window.open(shareLink, "_blank").focus();
                },
            },
        ],
    };

    return (
        <div className="flex items-center animation-fade-in">
            {/* <button
                className="rounded-full peer w-fit p-2 border-2 cursor-pointer border-kadComponentFocus hover:bg-kadComponentBg"
                onClick={() => {
                    if (!profile) {
                        showToast(
                            "INFO",
                            "Connect wallet first to write a article!"
                        );
                        return;
                    }
                    setDrawerVisible(!drawerVisible);
                }}
            >
                <GiFeather className="size-1" />
            </button>
            <GiBroadheadArrow className="size-2 md:size-1 mx-4 rotate-[135deg] peer-hover:size-2" />
            <span className="size-1">
                Let the community start reading your story
            </span> */}
            <div className={`flex flex-col w-full duration-150`}>
                {/* ${
                    drawerVisible ? "" : "translate-x-full"
                } */}
                {notice?.length !== 0 && (
                    <div className="absolute -top-8 -left-8 -bottom-8 -right-8 pt-16 backdrop-blur-sm z-[5] flex items-center justify-center">
                        <LoadingBar text={notice} />
                    </div>
                )}
                <input
                    className="size-1 hidden mb-4 hover:opacity-70 duration-150 border-0 bg-kadComponentBg"
                    placeholder="Title"
                    value={draft?.markdown.slice(0, 50)}
                    onChange={(e) => setSubject(e.target.value)}
                    onBlur={onBlurMarkdown}
                />

                <div className="flex gap-4">
                    <ProfileBadge profile={profile} />

                    <div className="flex flex-col">
                        <LinkWithSearchParams
                            className="hover:opacity-70"
                            to={{
                                pathname: `/profile/${profile?.username}`,
                            }}
                        >
                            {profile?.username}
                        </LinkWithSearchParams>
                        <span className="size-sm font-light opacity-70">
                            {new Date().toLocaleDateString("en-US", {})}
                        </span>
                    </div>
                </div>
                <textarea
                    placeholder="Enter text here..."
                    className="preview-article-content border-0 w-full"
                    value={draft?.markdown}
                    onChange={(e) => onChangeEditor(e.target.value)}
                    onBlur={onBlurMarkdown}
                />
                {draft?.giphyLink?.length > 0 && (
                    <div className="relative group">
                        <div
                            className="absolute w-full h-full hidden group-hover:flex items-center justify-center bg-kadComponentBg cursor-pointer"
                            onClick={() => {
                                setGiphyLink("");
                                onBlurMarkdown();
                            }}
                        >
                            <RiDeleteBin2Line className="size-4 p-2 bg-kadDarkBg rounded-lg fill-kadGrSt" />
                        </div>
                        <img
                            alt="giphy attachment"
                            src={draft?.giphyLink}
                            className="animation-enter w-full"
                        />
                    </div>
                )}
                {/* 
                {!isPreviewing ? (
                    <MDEditor
                        height="100%"
                        value={draft?.markdown}
                        onChange={onChangeEditor}
                        onBlur={onBlurMarkdown}
                        preview="edit"
                    />
                ) : (
                    <MDEditor.Markdown
                        source={draft?.markdown}
                        style={{
                            background: "transparent",
                        }}
                    />
                )} */}

                <div className="flex pt-2 gap-2">
                    <input
                        className="bg-kadComponentBg pl-4 size-sm border-0 w-full"
                        placeholder="Input tags, seperated by space, ex: web3 titanx presale"
                        value={draft?.tags.join(" ")}
                        onChange={(e) =>
                            setTags(
                                e.target.value
                                    .split(" ")
                                    .map((item) => item.trim())
                            )
                        }
                        onBlur={onBlurMarkdown}
                    />
                    <HoverList {...shareOptions} />
                    <HoverGiphy
                        icon={<AiOutlineGif />}
                        onGifClick={onGifClick}
                    />

                    {/* <button
                        className="ml-4 thiGr-button rounded-full size-sm"
                        onClick={() => setIsPreviewing(!isPreviewing)}
                    >
                        {!isPreviewing ? (
                            <VscEye className="size-1 mr-1" />
                        ) : (
                            <VscEyeClosed className="size-1 mr-1" />
                        )}
                        Preview
                    </button> */}
                    <button
                        className="blueGradient-button rounded-full size-sm"
                        onClick={onPublishDraft}
                    >
                        <MdPublish className="size-1" />
                        <span className="hidden md:block">Post</span>
                    </button>
                    {/* 
                    <button
                        type="button"
                        className="ace-modal-close-button ml-0"
                        onClick={() => setDrawerVisible(false)}
                    >
                        <svg
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default PostComposer;
